export default {_name:'text.iconBlock',module:'Field',view:'Element/Text/IconBlock',options:{direction:'column',textAlign:'center',md:12}}